/**
 * @file 加载指定url的脚本
 * @author mengke(kekee000@gmail.com)
 * @module util/loadScript
 */
/**
 * 加载指定url的脚本, 无论成功或者失败都会回调
 *
 * @param {string} url 脚本url
 * @param {Function} callback 回调函数
 */
export default function loadScript(url, callback) {
    const head = document.getElementsByTagName('head')[0];
    const script = document.createElement('script');
    script.type = 'text/javascript';
    script.charset = 'utf-8';
    script.onload = script.onreadystatechange = script.onerror = function onload() {
        if (!this.readyState || this.readyState === 'loaded' || this.readyState === 'complete') {
            this.onload = this.onreadystatechange = this.onerror = null;
            return callback();
        }
    };
    script.src = url;
    head.appendChild(script);
}
